var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "license-assign" },
    [
      _c("popup-panel"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "license-assign__subscription-manager" },
        [_c("subscription-manager", { attrs: { licenseAssignement: true } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "license-assign__buttons-container" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.choseALicense
                ? _vm.labels.buttons.cancel
                : _vm.labels.buttons.back_choose_admin_license,
              type: "secondary"
            },
            on: { click: _vm.goBack }
          }),
          _vm._v(" "),
          _vm.choseALicense
            ? _c("CompassButton", {
                attrs: {
                  label: _vm.labels.buttons.continue,
                  disabled: _vm.isContinueButtonDisabled
                },
                on: {
                  click: function($event) {
                    return _vm.goToUrl("/home")
                  }
                }
              })
            : _c("CompassButton", {
                attrs: { label: _vm.labels.buttons.disconnect },
                on: {
                  click: function($event) {
                    return _vm.goToUrl("/logout")
                  }
                }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }